import { render, staticRenderFns } from "./dash-chart-stat.vue?vue&type=template&id=503a1f41&scoped=true"
import script from "./dash-chart-stat.vue?vue&type=script&lang=js"
export * from "./dash-chart-stat.vue?vue&type=script&lang=js"
import style0 from "./dash-chart-stat.vue?vue&type=style&index=0&id=503a1f41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503a1f41",
  null
  
)

export default component.exports